import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import classNames from 'clsx';
import type { FC } from 'react';
import React, { useMemo } from 'react';

import semanticClassNames from '../SocialPlayerSnapchat.semanticClassNames';
import type { SocialPlayerSnapchatProps } from '../SocialPlayerSnapchat.types';
import classes from './SocialPlayerSnapchat.module.scss';
import { getEmbedUrl } from './getEmbedUrl';

const SocialPlayerSnapchat: FC<SocialPlayerSnapchatProps> = props => {
  const {
    id,
    className,
    customClassNames = [],
    url,
    onMouseEnter,
    onMouseLeave,
    description,
  } = props;

  const embedUrl = useMemo(() => {
    return getEmbedUrl(url);
  }, [url]);

  return (
    <div
      id={id}
      className={classNames(
        'socialPlayerSnapchat',
        classes.root,
        className,
        formatClassNames(semanticClassNames.root, ...customClassNames),
      )}
      style={{ display: 'flex', minHeight: 'fit-content' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...getDataAttributes(props)}
    >
      {!embedUrl ? null : (
        <iframe
          title={description}
          src={embedUrl}
          allow="autoplay; camera; microphone; clipboard-write;"
          width="100%"
          height="100%"
          loading="lazy"
          allowFullScreen={true}
          allowTransparency={true}
        />
      )}
    </div>
  );
};

export default SocialPlayerSnapchat;
